import '../styles/NavigationList.css';
import { Link, useLocation } from 'react-router-dom';

function NavigationList({ type }) {

    const { pathname } = useLocation();

    return (

        <ul className='navigation_c'>

            <li>

                <Link to='/' className={pathname === '/' ? (`${'active__item'} ${type}`) : type}>Início</Link>

            </li>

            <li>

                <Link to='/portfolio' className={pathname === '/portfolio' ? (`${'active__item'} ${type}`) : type}>Portfólio</Link>

            </li>

            <li>

                <Link to='/contato' className={pathname === '/contato' ? (`${'active__item'} ${type}`) : type}>Fale comigo</Link>

            </li>

        </ul>

    )

}

export default NavigationList;